import React from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import Input from '~/components/Inputs/Input';
import InputCurrency from '~/components/Inputs/InputCurrency';

export default function CompanyFields({
  disabled = false,
  disabledFields = {},
}) {
  const isDisabled = fieldName =>
    Boolean(disabledFields?.[fieldName] ?? disabled);

  return (
    <>
      <Row className="w-100 mx-0">
        <Col lg={6} className="px-0 pr-lg-2">
          <FormGroup>
            <Label>Nome Fantasia</Label>
            <Input
              disabled={isDisabled('fantasy_name')}
              name="fantasy_name"
              placeholder="Nome Fantasia"
            />
          </FormGroup>
        </Col>
        <Col lg={6} className="px-0 pl-lg-2">
          <FormGroup>
            <Label>Razão Social</Label>
            <Input
              disabled={isDisabled('trading_name')}
              name="trading_name"
              placeholder="Razão Social"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row className="w-100 mx-0">
        <Col lg={6} className="px-0 pr-lg-2">
          <FormGroup className="mb-0">
            <Label>Receita Anual</Label>
            <InputCurrency
              disabled={isDisabled('annual_revenue')}
              name="annual_revenue"
              placeholder="Receita Anual"
              type="text"
              currency
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
}
